import axios from "axios"
import ApplicationState from "../../../../Stores/applicationStates"

export const initiateDocument = () => {
  return new Promise(async (resolve, reject) => {
    try {
      if (!window.navigator.onLine) throw "P2BCODE::NETWORK_ERROR"

      let token
      ApplicationState.subscribe((state) => (token = state.token))

      const { data } = await axios.post(
        `/api/swagger/v2/documents?qrcode=true`,
        { filename: Date.now() },
        {
          headers: {
            "x-access-token": token,
          },
        }
      )

      if (data.error && !data.success) {
        throw data.errorCode
      }

      resolve(data)
    } catch (error) {
      reject(error)
    }
  })
}

export const fetchBadgeData = (id) => {
  return new Promise(async (resolve, reject) => {
    try {
      let token
      ApplicationState.subscribe((state) => (token = state.token))
      const { data } = await axios.get(`/api/swagger/v2/badge/${id}`, {
        headers: {
          "x-access-token": token,
        },
      })
      // console.log(data)

      if (data.error && !data.success) {
        throw data.errorCode // Throw the error code
      }

      resolve(data.badge)
    } catch (error) {
      reject(error)
    }
  })
}

export const fetchBadgeList = () => {
  return new Promise(async (resolve, reject) => {
    try {
      let token
      ApplicationState.subscribe((state) => (token = state.token))
      const { data } = await axios.get(`/api/swagger/v2/badge/`, {
        headers: {
          "x-access-token": token,
        },
      })
      // console.log(data)

      if (data.error && !data.success) {
        throw data.errorCode // Throw the error code
      }

      resolve(data)
    } catch (error) {
      reject(error)
    }
  })
}

export const fetchDocumentDetails = (id) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (!window.navigator.onLine) throw "P2BCODE::NETWORK_ERROR"

      let token
      ApplicationState.subscribe((state) => (token = state.token))

      const { data } = await axios.get(`/api/swagger/v2/documents/${id}`, {
        headers: {
          "x-access-token": token,
        },
      })

      if (data.error && !data.success) {
        throw data.errorCode
      }

      resolve(data.document)
    } catch (error) {
      reject(error)
    }
  })
}

export const fetchDocTempList = (querystring) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (!window.navigator.onLine) throw "P2BCODE::NETWORK_ERROR"

      let token
      ApplicationState.subscribe((state) => (token = state.token))

      // Fetching list of document templates
      const { data } = await axios.get(`/api/swagger/v2/templates/documents${querystring}`, {
        headers: {
          "x-access-token": token,
        },
      })

      // Check if the response has an error and is not successful
      if (data.error && !data.success) {
        throw data.errorCode // Throw the error code
      }

      resolve(data)
    } catch (error) {
      reject(error)
    }
  })
}
export const fetchBadgeTempList = (querystring) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (!window.navigator.onLine) throw "P2BCODE::NETWORK_ERROR"

      let token
      ApplicationState.subscribe((state) => (token = state.token))

      // Fetching list of document templates
      const { data } = await axios.get(`/api/swagger/v2/templates/badges${querystring}`, {
        headers: {
          "x-access-token": token,
        },
      })

      // Check if the response has an error and is not successful
      if (data.error && !data.success) {
        throw data.errorCode // Throw the error code
      }

      resolve(data)
    } catch (error) {
      reject(error)
    }
  })
}

export const fetchSingleDocTempDetails = (id) => {
  return new Promise(async (resolve, reject) => {
    try {
      // console.log(id, "id")
      if (!window.navigator.onLine) throw "P2BCODE::NETWORK_ERROR"

      let token
      ApplicationState.subscribe((state) => (token = state.token))

      // Fetching list of document templates
      const { data } = await axios.get(`/api/swagger/v2/templates/documents/${id}`, {
        headers: {
          "x-access-token": token,
        },
      })

      if (data.error && !data.success) {
        throw data.errorCode
      }

      resolve(data.template)
    } catch (error) {
      reject(error)
    }
  })
}

export const releaseDocument = (id) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (!window.navigator.onLine) throw "P2BCODE::NETWORK_ERROR"

      let token
      ApplicationState.subscribe((state) => (token = state.token))

      const { data } = await axios.delete(`/api/swagger/v2/documents/${id}/release`, {
        headers: {
          "x-access-token": token,
        },
      })

      // Check for errors in the API response
      if (data.error && !data.success) {
        throw data.errorCode // Throw the error code
      }

      resolve()
    } catch (error) {
      reject(error)
    }
  })
}

export const datahashGeneration = (id, reqBody) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (!window.navigator.onLine) throw "P2BCODE::NETWORK_ERROR"

      let token
      ApplicationState.subscribe((state) => (token = state.token))

      const { data } = await axios.patch(`/api/swagger/v2/documents/${id}/add-data`, reqBody, {
        headers: {
          "x-access-token": token,
        },
      })

      if (data.error && !data.success) {
        //throw if any error occurs during api call
        throw data.errorCode
      }

      resolve(data)
    } catch (error) {
      reject(error)
    }
  })
}

export const filehashGeneration = (id, reqBody) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (!window.navigator.onLine) throw "P2BCODE::NETWORK_ERROR"

      let token
      ApplicationState.subscribe((state) => (token = state.token))

      const { data } = await axios.patch(`/api/swagger/v2/documents/${id}/add-file`, reqBody, {
        headers: {
          "Content-Type": "multipart/form-data",
          "x-access-token": token,
        },
      })

      if (data.error && !data.success) {
        //throw if any error occurs during api call
        throw data.errorCode
      }

      resolve(data)
    } catch (error) {
      reject(error)
    }
  })
}

export const fetchSignature = (reqBody) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (!window.navigator.onLine) throw "P2BCODE::NETWORK_ERROR"

      let token
      ApplicationState.subscribe((state) => (token = state.token))

      const { data } = await axios.post(`/api/swagger/v2/misc/proxy-sign`, reqBody, {
        headers: {
          "x-access-token": token,
        },
      })
      if (data.error && !data.success) {
        //throw if any error occurs during api call
        throw data.errorCode
      }

      resolve(data.signature)
    } catch (error) {
      reject(error)
    }
  })
}

export const publishDocument = (id, reqBody) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (!window.navigator.onLine) throw "P2BCODE::NETWORK_ERROR"

      let token
      ApplicationState.subscribe((state) => (token = state.token))

      const { data } = await axios.post(`/api/swagger/v2/documents/${id}/publish`, reqBody, {
        headers: {
          "x-access-token": token,
        },
      })

      if (data.error && !data.success) {
        //throw if any error occurs during api call
        throw data.errorCode
      }

      resolve(data)
    } catch (error) {
      reject(error)
    }
  })
}

export const generateRevokeSignature = (reqBody) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (!window.navigator.onLine) throw "P2BCODE::NETWORK_ERROR"

      let token
      ApplicationState.subscribe((state) => (token = state.token))

      const { data } = await axios.post(`/api/swagger/v2/misc/proxy-sign`, reqBody, {
        headers: {
          "x-access-token": token,
        },
      })

      if (data.error && !data.success) {
        throw data.errorCode // Throw the error code
      }

      resolve(data.signature)
    } catch (error) {
      reject(error)
    }
  })
}

/**
 * @description function for documennt revoking.
 */
export const revokeDocument = async (reqBody) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (!window.navigator.onLine) throw "P2BCODE::NETWORK_ERROR"

      let token
      ApplicationState.subscribe((state) => (token = state.token))

      const { data } = await axios.post(`/api/swagger/v2/documents/${id}/revoke`, reqBody, {
        headers: {
          "x-access-token": token,
        },
      })
      if (data.error && !data.success) {
        throw data.errorCode // Throw the error code
      }
      resolve()
    } catch (error) {
      // console.error(error)
      reject(error)
    }
  })
}
